import report from './report';
export default {
    list: report,
};
